import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';

// Schemas
const questionAnswerSchema = Yup.object().shape({
  question: Yup.string().required('Question is required'),
  answer: Yup.string().required('Answer is required')
});

// Types
export type QuestionAnswerData = Yup.InferType<typeof questionAnswerSchema>;

// Resolvers
export const questionAnswerResolver = yupResolver(questionAnswerSchema);
